import React from 'react';
import './AboutHeroArea.css';

const AboutHeroArea = () => {
    return (
        <div className="about-hero-section">
            <div className="about-bgOverlay">
                <div className="container">
                    <div className="about-hero-content">
                        <h4>Home / About Us</h4>
                        <h1>About Us</h1>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutHeroArea;